import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import _ from "lodash";
import moment from "moment";
import TitleBar from "../_common/TitleBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddIssueModal from "./AddIssueModal";
import "./issueTracker.css";
import IssuePreview from "./IssuePreview";
import { actionScripts } from "../../_helpers/actionScripts";

// Constants for status IDs
const STATUS_IDS = {
  OPEN: 0,
  RESOLVED: 1,
  CLOSED: 2,
};

class IssueTracker extends Component {
  state = {
    showAddIssueModal: false,
    selectedIssue: null,
    descFilter: "",
    priorityFilter: { value: "", label: "Priority: All" },
    typeFilter: { value: "", label: "Type: All" },
    activeTypeFilters: [], // array of selected type IDs (e.g., [0, 2])
    selectedTab: "open", // Track the active tab ("open" or "closed")
  };

  priorityEnum = ["Low", "Medium", "High", "Critical"];
  priorityClasses = ["secondary", "warning", "danger", "dark"];
  statusEnum = ["Open", "Resolved", "Closed"];
  typeEnum = ["Bug", "Suggestion", "Question"];
  typeIconEnum = ["bug", "lightbulb", "question-circle"];

  priorityList = [{ value: null, label: "Priority: All" }].concat(
    this.priorityEnum.map((p, value) => ({
      value,
      label: "Priority: " + p,
    }))
  );

  typeList = [{ value: null, label: "Type: All" }].concat(
    this.typeEnum.map((t, value) => ({
      value,
      label: "Type: " + t,
    }))
  );


  handleChange_descFilter = (e) => this.setState({ descFilter: e.target.value });
  handleChange_priorityFilter = (priorityFilter) => this.setState({ priorityFilter });
  handleChange_typeFilter = (typeFilter) => this.setState({ typeFilter });

  handleClick_issue = (selectedIssue) => (e) => {
    e.preventDefault();
    this.setState({ selectedIssue });
  };

  handleClick_openIssue = (issueId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.openIssue(issueId);
  };

  openIssue = (issueId) => {
    try {
      if (actionScripts?.OPEN_ISSUE?.run) {
        actionScripts.OPEN_ISSUE.run(issueId);
      } else {
        console.error("OPEN_ISSUE action script not available");
      }
    } catch (error) {
      console.error("Error opening issue:", error);
    }
  };

  toggleAddIssueModal = () =>
    this.setState({ showAddIssueModal: !this.state.showAddIssueModal });

  refreshSelectedIssue = () => {
    const { selectedIssue } = this.state;
    if (!selectedIssue) return;

    const { issueList } = this.props;
    const refreshedIssue = issueList.find((i) => i.issueId === selectedIssue.issueId);

    // If !refreshedIssue, revert to existing selectedIssue
    this.setState({
      selectedIssue: refreshedIssue ? refreshedIssue : selectedIssue,
    });
  };

  getTypeSnippetClass = (issueTypeId) => {
    let className = "fa-fw mt-1 mr-2 text-";
    const typeSnippetColors = ["danger", "info", "secondary"];
    return (className += typeSnippetColors[issueTypeId]);
  };

  getIssueClassName = (issueId) => {
    const { selectedIssue } = this.state;
    let className = "list-group-item pointer-cursor";
    if (selectedIssue && selectedIssue.issueId === issueId)
      className += " bg-table-primary";
    return className;
  };

  renderPriority = (issue, isSmall = false) => {
    const spanBubble = isSmall ? "span-bubble-small py-0 " : "span-bubble py-1 ";
    const priorityClass =
      spanBubble + "px-1 mt-1 bg-" + this.priorityClasses[issue.issuePriorityId];
    const priorityCaption = this.priorityEnum[issue.issuePriorityId];
    return <span className={priorityClass}>{priorityCaption}</span>;
  };

  renderStatus = (issue) => {
    const statusCaption = this.statusEnum[issue.issueStatusId];
    return (
      <span className="span-bubble p-1 bg-secondary">
        <small>{statusCaption}</small>
      </span>
    );
  };

  renderIssueList = (issues) => {
    return (
      <div className="d-flex">
        <div className="list-group flex-grow-1 issue-list-container">
          <div className="list-group-item bg-lightgray">Posted Issues</div>
          {issues && issues.length > 0 ? (
            issues.map((issue, index) => (
              <div
                key={`issueItemKey_${issue.issueId}`}
                className={this.getIssueClassName(issue.issueId)}
                onClick={this.handleClick_issue(issue)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.handleClick_issue(issue)(e);
                  }
                }}
                aria-label={`Issue ${issue.issueId}: ${issue.title}`}
              >
                <div className="d-flex flex-row justify-content-between">
                  <div>
                    <FontAwesomeIcon
                      icon={this.typeIconEnum[issue.issueTypeId]}
                      className={this.getTypeSnippetClass(issue.issueTypeId)}
                      aria-hidden="true"
                    />
                    <span className="mr-2 h6">{issue.title}</span>
                    {this.renderPriority(issue, true)}
                  </div>
                  <div>
                    {issue.posts.length > 0 && (
                      <small className="text-muted">
                        <FontAwesomeIcon icon="comment" className="fa-fw mr-1" aria-hidden="true" />
                        {issue.posts.length}
                      </small>
                    )}
                    {issue.followers.length > 0 && (
                      <small className="text-muted">
                        <FontAwesomeIcon icon="eye" className="fa-fw mr-1 ml-2" aria-hidden="true" />
                        {issue.followers.length}
                      </small>
                    )}
                    <button
                      type="button"
                      name={`gotoIssue_${index}`}
                      id={`gotoIssue_${index}`}
                      className="btn btn-sm btn-outline-secondary ml-3 px-1 py-0"
                      onClick={this.handleClick_openIssue(issue.issueId)}
                      aria-label={`Open issue ${issue.issueId} in new view`}
                    >
                      <small>
                        <FontAwesomeIcon icon="external-link-alt" className="fa-fw" aria-hidden="true" />
                      </small>
                    </button>
                  </div>
                </div>
                <div className="d-flex flex-row justify-content-between">
                  <div>
                    <FontAwesomeIcon
                      icon="circle"
                      className="fa-fw mt-1 mr-2 icon-invisible"
                      aria-hidden="true"
                    />
                    <small>
                      Issue #{issue.issueId} - opened on{" "}
                      {moment(issue.createdOn).format("MM/DD/YYYY")} by{" "}
                      {issue.createdByUserFullName}
                    </small>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="list-group-item text-muted text-center py-4">
              No issues found matching the current filters
            </div>
          )}
        </div>
      </div>
    );
  };

  handleClick_clearFilters = () => {
    this.setState({
      descFilter: "",
      priorityFilter: { value: "", label: "Priority: All" },
      typeFilter: { value: "", label: "Type: All" },
    });
  };

  handleTabChange = (tab) => {
    this.setState({ selectedTab: tab, selectedIssue: null }); // Clear selection on tab change
  };

  getFilteredIssues = () => {
    const { issueList } = this.props;
    const { descFilter, priorityFilter, typeFilter, selectedTab } = this.state;

    if (!issueList) return [];

    let filtered = issueList;

    // Filter by title and description
    if (descFilter !== "") {
      const searchTerm = descFilter.trim().toLowerCase();
      filtered = filtered.filter((i) =>
        i.title?.toLowerCase().includes(searchTerm) ||
        i.bodyText?.toLowerCase().includes(searchTerm)
      );
    }

    // Filter by priority
    if (priorityFilter && priorityFilter.value !== "") {
      filtered = filtered.filter(
        (i) => i.issuePriorityId === priorityFilter.value
      );
    }

    // Filter by type
    if (typeFilter && typeFilter.value !== "") {
      filtered = filtered.filter(
        (i) => i.issueTypeId === typeFilter.value
      );
    }

    if (selectedTab === "open") {
      filtered = filtered.filter((i) =>
        i.issueStatusId === STATUS_IDS.OPEN || i.issueStatusId === STATUS_IDS.RESOLVED
      );
    } else if (selectedTab === "closed") {
      filtered = filtered.filter((i) => i.issueStatusId === STATUS_IDS.CLOSED);
    }

    return _.orderBy(filtered, "issueId", "desc");
  };

  render() {
    const { userId } = this.props;
    const { descFilter, priorityFilter, typeFilter, showAddIssueModal, selectedIssue, selectedTab } = this.state;
    const filteredIssues = this.getFilteredIssues();

    return (
      <React.Fragment>
        <TitleBar titleText="Issue Tracker" />
        <div className="card m-2">
          <div className="card-body p-2">
            <div>
              <h5>Help &amp; Support</h5>
              <b>User Guides - </b>
              <a href="https://des.onramp.dot.ca.gov/prodms-guides-and-manuals" target="_blank" rel="noopener noreferrer"> https://des.onramp.dot.ca.gov/prodms-guides-and-manuals</a>
            </div>
            <b>Live Support - </b>
            Join our Power Hour every Friday from 10:00AM to 11:00AM for real-time assistance. <br/>
            <a href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZmZhZThhOWMtNzA0YS00YjBhLWFhYjItYmY2YzVjZWI3ZTU2%40thread.v2/0?context=%7b%22Tid%22%3a%22621b0a64-1740-43cc-8d88-4540d3487556%22%2c%22Oid%22%3a%22b6c01b5d-5feb-4ea4-8645-694f09145c6c%22%7d"
              target="_blank" rel="noopener noreferrer" style={{ marginLeft: '7rem' }}>
                <b>Click here to join the meeting</b>
            </a>
          </div>
        </div>
        <div className="card m-2">
          <div className="card-body p-2">
            {/* Tabs for Open, Closed, and All Issues */}
            <div className="form-row mb-2 align-items-center">
              <div className="col-auto" role="tablist">
                <button
                  className={`btn ${selectedTab === "open" ? "btn-primary" : "btn-outline-primary"} mr-2`}
                  onClick={() => this.handleTabChange("open")}
                  role="tab"
                  aria-selected={selectedTab === "open"}
                  aria-label="Show open issues"
                >
                  Open Issues
                </button>
                <button
                  className={`btn ${selectedTab === "closed" ? "btn-primary" : "btn-outline-primary"} mr-2`}
                  onClick={() => this.handleTabChange("closed")}
                  role="tab"
                  aria-selected={selectedTab === "closed"}
                  aria-label="Show closed issues"
                >
                  Closed Issues
                </button>
                <button
                  className={`btn ${selectedTab === "all" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => this.handleTabChange("all")}
                  role="tab"
                  aria-selected={selectedTab === "all"}
                  aria-label="Show all issues"
                >
                  All Issues
                </button>
              </div>
            </div>

            {/* Filters */}
            <div className="form-row mb-2">
              <div className="col-12 col-md-4 col-lg-3 mb-2 mb-md-0 pr-md-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-lightgray">
                      <FontAwesomeIcon icon="search" className="fa-fw text-muted" aria-hidden="true" />
                    </span>
                  </div>
                  <input
                    name="descFilter"
                    id="descFilter"
                    className="form-control"
                    value={descFilter}
                    onChange={this.handleChange_descFilter}
                    placeholder="Search title or description"
                    aria-label="Search issues by title or description"
                  />
                </div>
              </div>
              <div className="col-6 col-md-3 col-lg-2 mb-2 mb-md-0 pr-2 pr-md-2">
                <Select
                  name="typeFilter"
                  id="typeFilter"
                  value={typeFilter}
                  options={this.typeList}
                  onChange={this.handleChange_typeFilter}
                  isSearchable={false}
                  placeholder="Type"
                  aria-label="Filter issues by type"
                />
              </div>
              <div className="col-6 col-md-3 col-lg-2 mb-2 mb-md-0 pr-2 pr-md-2">
                <Select
                  name="priorityFilter"
                  id="priorityFilter"
                  value={priorityFilter}
                  options={this.priorityList}
                  onChange={this.handleChange_priorityFilter}
                  isSearchable={false}
                  placeholder="Priority"
                  aria-label="Filter issues by priority"
                />
              </div>
              <div className="col-6 col-md-auto mb-2 mb-md-0 pr-2">
                <button
                  type="button"
                  name="clearIssueFilter"
                  id="clearIssueFilter"
                  className="btn btn-secondary w-100"
                  onClick={this.handleClick_clearFilters}
                  aria-label="Clear all filters"
                >
                  Clear
                </button>
              </div>
              <div className="col-6 col-md-auto mb-2 mb-md-0">
                <button
                  type="button"
                  name="addNewIssue"
                  id="addNewIssue"
                  className="btn btn-info w-100"
                  onClick={this.toggleAddIssueModal}
                  aria-label="Create new issue"
                >
                  <FontAwesomeIcon icon="bug" className="fa-fw mr-1" aria-hidden="true" />
                  New Issue...
                </button>
              </div>
            </div>

            {/* Issue List */}
            <div className="form-row">
              <div className="col-md-7 pr-1">{this.renderIssueList(filteredIssues)}</div>
              <div className="col-md-5 pl-1">
                <IssuePreview
                  issue={selectedIssue}
                  isFollowing={
                    selectedIssue &&
                    selectedIssue.followers.some((f) => f.followerUserId === userId)
                  }
                  refreshSelectedIssue={this.refreshSelectedIssue}
                  renderPriority={this.renderPriority}
                  statusEnum={this.statusEnum}
                  typeEnum={this.typeEnum}
                  openIssue={this.openIssue}
                />
              </div>
            </div>
          </div>
        </div>
        {showAddIssueModal && (
          <AddIssueModal
            showAddIssueModal={showAddIssueModal}
            toggleAddIssueModal={this.toggleAddIssueModal}
            typeEnum={this.typeEnum}
            priorityEnum={this.priorityEnum}
            userId={userId}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  issueList: Object.values(state.issues.issueList),
  userId: state.authentication.user.userId,
});

export default connect(mapStateToProps)(IssueTracker);
